import styled from 'styled-components';

import { BasicParagraph } from '../../../../foundations/typefaces/BasicParagraph';
import { BasicSubtitle } from '../../../../foundations/typefaces/BasicSubtitle';
import style from '../../../../style';
import type { Color } from '../../../../style/types/theme';
import { Wrapper as StyledLeftComponent } from './components/LeftComponent/LeftComponent.styled';

interface ItemProps {
  $isActive?: boolean;
  $isClickable?: boolean;
  $keepRightComponentsVisible?: boolean;
  $shouldKeepHoverStyle?: boolean;
}

export const NameContainer = styled.div(({ theme: { size } }) => ({
  overflow: 'hidden',
  paddingRight: size.units(1),
}));

export const StyledBasicParagraph = styled(BasicParagraph)(
  ({ theme: { color, transition } }) => ({
    color: color.content.secondary.default(),
    transition: transition.standard('color'),
    ...style.mixins.ellipsis(true),
  }),
);

export const StyledBasicSubtitle = styled(BasicSubtitle)(() => ({
  ...style.mixins.ellipsis(true),
}));

export const LeftComponentContainer = styled.div({
  display: 'flex',
});

export const PremiumLabelContainer = styled.div(() => ({
  display: 'flex',
}));

export const RightComponentContainer = styled.div(() => ({
  display: 'flex',
}));

export const RightContainer = styled.div<ItemProps>(
  ({ theme: { size, transition }, $keepRightComponentsVisible }) => ({
    display: 'flex',
    width: $keepRightComponentsVisible ? '100%' : 0,
    opacity: $keepRightComponentsVisible ? 1 : 0,
    transition: transition.standard('width', 'opacity'),
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: 1,
    'column-gap': size.units(1.5),

    ...style.mixins.devices.touchable({
      width: '100%',
      opacity: 1,
    }),
  }),
);

const getBakgroundColor = (
  color: Color,
  isActive?: boolean,
  shouldKeepHoverStyle?: boolean,
) => {
  if (isActive) {
    return color.background.quaternary.active();
  }
  return shouldKeepHoverStyle ? color.background.quaternary.hover() : 'transparent';
};

export const Container = styled.div<ItemProps>(
  ({
    theme: { size, color, transition, borderRadius },
    $isClickable,
    $isActive,
    $shouldKeepHoverStyle,
  }) => ({
    cursor: $isClickable ? 'pointer' : 'default',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: size.units(4),
    transition: transition.standard('background-color'),
    padding: `0 ${size.units(1)} 0 ${size.units(1)}`,
    backgroundColor: getBakgroundColor(color, $isActive, $shouldKeepHoverStyle),
    borderRadius: borderRadius.small,

    [`${LeftComponentContainer} + ${NameContainer}`]: {
      paddingLeft: size.units(1.5),
    },

    [`${StyledLeftComponent} svg`]: {
      color: $isActive
        ? color.content.primary.default()
        : color.content.secondary.default(),
    },

    '&:hover': {
      backgroundColor: $isActive
        ? color.background.quaternary.active()
        : color.background.quaternary.hover(),
    },

    ...style.mixins.devices.desktop({
      '&:hover': {
        [`${StyledBasicParagraph}, ${StyledLeftComponent} svg`]: {
          color:
            $isClickable || $isActive
              ? color.content.primary.hover()
              : color.content.reversed.hover(),
        },

        [RightContainer]: {
          width: '100%',
          opacity: 1,
        },
      },
    }),
  }),
);

export const Wrapper = styled.div({
  width: '100%',
});
